import ESSDashboardPage from '../modules/dashboard-pages/ESSDashboardPage';
import HRDashboardPage from '../modules/dashboard-pages/HRDashboardPage';
import FSMDashboardPage from '../modules/dashboard-pages/FSMDashboardPage';
import CRMDashboardPage from '../modules/dashboard-pages/CRMDashboardPage';
import IMSDashboardPage from '../modules/dashboard-pages/IMSDashboardPage';
import PMSDashboardPage from '../modules/dashboard-pages/PMSDashboardPage';
import { Routes, Route, Navigate, useSearchParams, useParams } from 'react-router-dom';

import {
  ApplyLeavePage,
  LeaveHistoryPage,
  LeavePortal,
  ManagerDashboard,
  ManagerLeaveRequestsPage,
} from '../modules/leave-management/pages';

import { EmployeeInfoPage } from '../modules/employee-info/pages/EmployeeInfoPage';

import { CustomerListPage, CustomerOnboardingPage, CustomerViewPage } from '../modules/crm/pages';
import {
  CRM_ONBOARDING_LIST_PATH,
  CRM_ONBOARDING_ADD_PATH,
  CRM_ONBOARDING_EDIT_PATH,
} from '../modules/crm/routes';

import {
  AttendanceListPage,
  MarkAttendancePage,
  RegularizationPage,
  TeamAttendancePage,
} from '../modules/attendance-management/pages';

import{
  FsmCreateTicketPage,
  FsmTicketsPage,
  FsmTicketDetailContainer,
  FsmChecklistsListPage,
  FsmChecklistTemplateFormPage,
  ProductServicesPage,
  ProductComplaintTypesPage,
} from '../modules/fsm/pages';

import {
  AdminHolidaysPage,
  ESSHolidaysPage,
} from '../modules/holiday-management/pages';

import { OrgTablesPage } from '../modules/org-tables/pages';

import { RolesListPage } from '../modules/roles-permissions/pages/RolesListPage';
import { CreateEditRolePage, EditRoleRoutePage } from '../modules/roles-permissions/pages/CreateEditRolePage';

import {
   TenantRegistryPage,
   CreateEditTenantPage,
   EditTenantRoutePage,
   AssignTenantAccessPage,
 } from '../modules/tenant-management/pages';

import {
  SubmoduleFeaturesPage,
  EmployeeInformationPage,
  CurrentEmploymentPage,
  ShiftMappingPage,
  PreviousEmploymentPage,
  EducationRecordsPage,
  EmployeeDocumentsPage,
  AccountDetailsPage,
  EmergencyInfoPage,
  AssetsAccessPage,
  PositionHistoryPage,
  EmployeeListPage,
  EmployeeOnboardingPage
} from '../modules/service-explorer/pages';

import { ShiftsListPage,
    CreateEditShiftPage,
    EditShiftRoutePage,
    ShiftDetailPage }
    from '../modules/organization-shifts/pages';

import { OrgChartPage, UnassignedPage } from '../modules/org-charts/pages';

import {
  PmcCostHeadsPage,
  QuotationPage,
  QuotationCreatePage,
  QuotationDetailPage,
} from '../modules/sales-quotation';

import {
  ESSAnnouncementsPage,
  AnnouncementDetailPage,
  CreatorAnnouncementsPage,
  CreatorAnnouncementDetailPage,
  HRReviewRequestsPage
} from '../modules/announcements/pages';

import { ChangePasswordPage } from '../modules/profile-settings/pages/ChangePasswordPage';
  
import {
MyPollsPage,
HRPollLogPage,
PollDashboardPage,
VotePollPage,
PollResultsPage,
ESSPollResultsPage,
} from '../modules/polls/pages';

import { DashboardConfigPage } from '../modules/dashboard-config/DashboardConfigPage';

import {
   LeadsPage,
   CreateLeadPage,
   LeadDetailPage,
   CaseIndexPage,
   ActivitiesPage,
   MessagesPage,
 } from '../modules/lead-management/pages';

import { TenantAnnouncementsPage } from '../modules/tenant-announcements/TenantAnnouncementsPage';

import {
  InventoryManagementPage,
  RecordInventoryPage,
  CustomerAllocationsPage,
  DeliveryChallanPage,
  RecordInventoryInPage,
  AllocateToCustomerPage,
  AllocationDetailPage,
  StockTransferPage,
  StockPositionDetailPage,
  ReorderAlertsPage,
  RevokeUnlockRequestsPage,
} from '../modules/inventory-management';

import {
  ProductCatalog,
  ProductDetail,
  AddEditProduct,
  VendorCatalog,
  VendorDetail,
  AddEditVendor,
  WarehouseList,
  AddEditWarehouse,
  WarehouseDetail,
  ConfigureWarehouseStockLevels,
} from '../modules/inventory/pages';

 import {
  TicketsListPage,
  CreateEditTicketPage,
  EditTicketRoutePage,
  TicketDetailPage,
} from '../modules/ticket_management/pages';


import {
  ConveyancePolicyConfigPage,
  MyConveyanceClaimsPage,
  RatePerKmClaimPage,
  FixedMonthlyClaimPage,
  VehicleMaintenanceClaimPage,
  TeamConveyanceClaimsPage,
  AllConveyanceClaimsPage,
  ClaimApprovalDetailPage,
} from '../modules/org-local-conveyance/pages';

import {
  OTRListPage,
   OTRReportPage,
  CreateEditOTRPage,
  OTRDetailPage,
  OTRExpenseSubmissionPage,
  TravelPolicyConfigPage,
} from '../modules/outstation-travel/pages';

import { CustomerAssetsPage, CustomerAssetFormPage } from '../modules/crm/Customer Assets';

import { OrgSettingsPage } from '../modules/org-settings/OrgSettingsPage';


import { OnboardingRequestsPage } from '../modules/onboarding-requests/OnboardingRequestsPage';
import { OnboardingRequestDetailPage } from '../modules/onboarding-requests/OnboardingRequestDetailPage';
import { TenantRequestsPage } from '../modules/tenant-requests/TenantRequestsPage';

import { MastersConfigurationPage } from '../modules/product-metrics/MastersConfigurationPage';

import { WeeklyScheduleConfigPage } from '../modules/weekly-work-schedule/pages';

function RedirectLegacyCustomerInformation() {
  const [searchParams] = useSearchParams();
  const editId = searchParams.get('edit');
  if (editId) {
    return <Navigate to={CRM_ONBOARDING_EDIT_PATH(editId)} replace />;
  }
  return <Navigate to={CRM_ONBOARDING_ADD_PATH} replace />;
}

function RedirectLegacyCustomerContact() {
  const { id } = useParams();
  if (id) {
    return <Navigate to={CRM_ONBOARDING_EDIT_PATH(id)} replace />;
  }
  return <Navigate to={CRM_ONBOARDING_LIST_PATH} replace />;
}

/**
 * All pages merged in from src_other. They keep the exact same relative
 * layout (Header + Sidebar + page body) and the exact same paths they were
 * given in the original TanStack `routes/*.jsx` file-based router — just
 * mounted under `/hrms/*` here instead of at the domain root, so they can
 * live alongside the login/welcome flow that already owns `/`.
 *
 * See router/navigation.js -> ROUTE_LINKS for how the sidebar and the
 * dashboard's service/module drawer deep-link into these routes.
 */
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="dashboards/ess" element={<ESSDashboardPage />} />
      <Route path="dashboards/hr" element={<HRDashboardPage />} />
      <Route path="dashboards/fsm" element={<FSMDashboardPage />} />
      <Route path="dashboards/crm" element={<CRMDashboardPage />} />
      <Route path="dashboards/ims" element={<IMSDashboardPage />} />
      <Route path="dashboards/pms" element={<PMSDashboardPage />} />

      {/* Paths are relative to parent /hrms/* — do NOT use leading slashes 
      <Route index element={<LeavePortal />} /> */}
      <Route path="hrms-team/manager" element={<ManagerDashboard />} />
      <Route path="hrms-ess/apply-leave" element={<ApplyLeavePage />} />
      <Route path="hrms-ess/leave-history" element={<LeaveHistoryPage />} />
      <Route path="hrms-team/leave-history" element={<LeaveHistoryPage />} />
      <Route path="hrms-team/leave-requests" element={<ManagerLeaveRequestsPage />} />
      <Route path="hrms-ess/attendance" element={<AttendanceListPage />} />
      <Route path="hrms-ess/attendance/mark" element={<MarkAttendancePage />} />
      <Route path="hrms-ess/attendance/regularization" element={<RegularizationPage />} />
      <Route path="hrms-ess/leave-report" element={<LeavePortal />} />
      <Route path="hrms-team/attendance" element={<TeamAttendancePage />} />
      <Route path="hrms-ess/holidays" element={<ESSHolidaysPage />} />
      <Route path="hrms-team/config/holidays" element={<AdminHolidaysPage />} />
      <Route path="hrms-team/config/org-tables" element={<OrgTablesPage />} />
      <Route path="hrms-team/config/roles-services" element={<RolesListPage />} />
      <Route path="hrms-team/config/roles-services/create" element={<CreateEditRolePage />} />
      <Route path="hrms-team/config/roles-services/edit/:id" element={<EditRoleRoutePage />} />
      <Route path="hrms-team/onboarding/employee-information" element={<EmployeeInformationPage />} />
      <Route path="hrms-team/onboarding/current-employment" element={<CurrentEmploymentPage />} />
      <Route path="hrms-team/onboarding/shift-mapping" element={<ShiftMappingPage />} />
      <Route path="hrms-team/onboarding/previous-employment" element={<PreviousEmploymentPage />} />
      <Route path="hrms-team/onboarding/education-records" element={<EducationRecordsPage />} />
      <Route path="hrms-team/onboarding/employee-documents" element={<EmployeeDocumentsPage />} />
      <Route path="hrms-team/onboarding/account-details" element={<AccountDetailsPage />} />
      <Route path="hrms-team/onboarding/emergency-info" element={<EmergencyInfoPage />} />
      <Route path="hrms-team/onboarding/assets-access" element={<AssetsAccessPage />} />
      <Route path="hrms-team/onboarding/position-history" element={<PositionHistoryPage />} />
      <Route path="hrms-ess/announcements" element={<ESSAnnouncementsPage />} />
      <Route path="hrms-ess/announcements/detail/:id" element={<AnnouncementDetailPage />} />
      <Route path="hrms-team/announcements/review" element={<HRReviewRequestsPage />} />
      <Route path="hrms-team/announcements/detail/:id" element={<CreatorAnnouncementDetailPage />} />
      <Route path="hrms-team/announcements" element={<CreatorAnnouncementsPage />} />
      <Route path="hrms-team/config/dashboards" element={<DashboardConfigPage />} />

      <Route path="hrms-team/onboarding/employee-information" element={<EmployeeInformationPage />} />
      <Route path="hrms-team/onboarding/employees" element={<EmployeeListPage />} />
      <Route path="hrms-team/onboarding/employees/onboard" element={<EmployeeOnboardingPage />} />

      <Route path="psm/tenant-announcements" element={<TenantAnnouncementsPage />} />

      <Route path="hrms-ess/org-chart" element={<OrgChartPage />} />
      <Route path="hrms-ess/org-chart/unassigned" element={<UnassignedPage />} />
      <Route path="hrms-ess/employee-info" element={<EmployeeInfoPage showSearch={false} />} />
      <Route path="hrms-team/employee-info" element={<EmployeeInfoPage showSearch />} />
      <Route path="hrms-team/config/shifts" element={<ShiftsListPage />} />
      <Route path="hrms-team/config/shifts/create" element={<CreateEditShiftPage />} />
      <Route path="hrms-team/config/shifts/edit/:id" element={<EditShiftRoutePage />} />
      <Route path="hrms-team/config/shifts/:id" element={<ShiftDetailPage />} />

     <Route path="hrms-ess/polls" element={<PollDashboardPage />} />
     <Route path="hrms-ess/polls/vote/:id" element={<VotePollPage />} />
     <Route path="hrms-ess/polls/results/:id" element={<ESSPollResultsPage />} />
     <Route path="hrms-team/polls/log" element={<HRPollLogPage />} />
     <Route path="hrms-team/polls/results/:id" element={<PollResultsPage />} />
     <Route path="hrms-team/polls" element={<MyPollsPage />} />
     <Route path="hrms-team/config/weekly-work-schedule" element={<WeeklyScheduleConfigPage />} />
      
     <Route path="psm/config/tenants" element={<TenantRegistryPage />} />
     <Route path="psm/config/tenants/create" element={<CreateEditTenantPage />} />
     <Route path="psm/config/tenants/edit/:id" element={<EditTenantRoutePage />} />
     <Route path="psm/config/tenants/access/:id" element={<AssignTenantAccessPage />} />

       {/* CRM Module Routes */}
      <Route path="services/CRM/Onboard Customer/Customer Assets" element={<CustomerListPage />} />
      <Route path="services/CRM/Onboard Customer/Customer Asset" element={<CustomerListPage />} />
      <Route path="crm/customers" element={<CustomerListPage />} />
      <Route path="crm/customer-information" element={<CustomerOnboardingPage />} />
      <Route path="crm/customer-contact/:id" element={<CustomerOnboardingPage />} />
      <Route path="services/CRM/Customer/Customer-Assets" element={<CustomerAssetsPage />} />
      <Route path="services/CRM/Customer/Customer-Assets/add" element={<CustomerAssetFormPage />} />
      <Route path="services/CRM/Customer/Customer-Assets/edit/:assetId" element={<CustomerAssetFormPage />} />

      <Route path="hrms-ess/change-password" element={<ChangePasswordPage />} />
     
      <Route path="hrms-ess/polls" element={<PollDashboardPage />} />
      <Route path="hrms-ess/polls/vote/:id" element={<VotePollPage />} />
      <Route path="hrms-ess/polls/results/:id" element={<ESSPollResultsPage />} />
      <Route path="hrms-team/polls/log" element={<HRPollLogPage />} />
      <Route path="hrms-team/polls/results/:id" element={<PollResultsPage />} />
      <Route path="hrms-team/polls" element={<MyPollsPage />} />

      <Route path="fsm/create-customer-complaint" element={<FsmCreateTicketPage/>} />
      <Route path="fsm/customer-complaints/:id" element={<FsmTicketDetailContainer/>} />
      <Route path="fsm/customer-complaints" element={<FsmTicketsPage/>} />
      <Route path="fsm/complaints-checklist/add" element={<FsmChecklistTemplateFormPage/>} />
      <Route path="fsm/complaints-checklist/update/:id" element={<FsmChecklistTemplateFormPage/>} />
      <Route path="fsm/complaints-checklist" element={<FsmChecklistsListPage/>} />

      {/* CRM Module Routes — Home → CRM → Customer → Onboarding */}
      <Route path="services/CRM/Customer/Onboarding" element={<CustomerListPage />} />
      <Route path="services/CRM/Customer/Onboarding/add" element={<CustomerOnboardingPage />} />
      <Route path="services/CRM/Customer/Onboarding/edit/:customerId" element={<CustomerOnboardingPage />} />
      <Route path="services/CRM/Customer/Onboarding/view/:customerId" element={<CustomerViewPage />} />

      {/* Legacy CRM path redirects */}
      <Route path="services/CRM/Onboard Customer/Customer Assets" element={<Navigate to={CRM_ONBOARDING_LIST_PATH} replace />} />
      <Route path="services/CRM/Onboard Customer/Customer Asset" element={<Navigate to={CRM_ONBOARDING_LIST_PATH} replace />} />
      <Route path="crm/customers" element={<Navigate to={CRM_ONBOARDING_LIST_PATH} replace />} />
      <Route path="crm/customer-information" element={<RedirectLegacyCustomerInformation />} />
      <Route path="crm/customer-contact/:id" element={<RedirectLegacyCustomerContact />} />

      <Route path="crm/lead-management/leads" element={<LeadsPage />} />
      <Route path="crm/lead-management/leads/create" element={<CreateLeadPage />} />
      <Route path="crm/lead-management/leads/:leadId" element={<LeadDetailPage />} />
      <Route path="crm/lead-management/leads/:leadId/case-index" element={<CaseIndexPage />} />
      <Route path="crm/lead-management/leads/:leadId/activities" element={<ActivitiesPage />} />
      <Route path="crm/lead-management/leads/:leadId/messages" element={<MessagesPage />} />

      <Route path="inventory-management" element={<Navigate to="/inventory-management/stock-position" replace />} />
      <Route path="inventory-management/stock-position" element={<InventoryManagementPage />} />
      <Route path="inventory-management/stock-position/:productId" element={<StockPositionDetailPage />} />
      <Route path="inventory-management/record-inventory-in" element={<RecordInventoryPage />} />
      <Route path="inventory-management/record-inventory-in/create" element={<RecordInventoryInPage />} />
      <Route path="inventory-management/record-inventory-in/edit/:inventoryInId" element={<RecordInventoryInPage />} />
      <Route path="inventory-management/allocate-to-customer" element={<AllocateToCustomerPage />} />
      <Route path="inventory-management/allocate-to-customer/edit/:allocationId" element={<AllocateToCustomerPage />} />
      <Route path="inventory-management/customer-allocations" element={<CustomerAllocationsPage />} />
      <Route path="inventory-management/allocation-detail/:allocationId" element={<AllocationDetailPage />} />
      <Route path="inventory-management/stock-transfer" element={<StockTransferPage />} />
      <Route path="inventory-management/reorder-alerts" element={<ReorderAlertsPage />} />
      <Route path="inventory-management/revoke-unlock-requests" element={<RevokeUnlockRequestsPage />} />
      <Route path="inventory-management/delivery-challan" element={<DeliveryChallanPage />} />

      <Route path="product-metrics" element={<MastersConfigurationPage />} />

      {/* IMS → Inventory Management → Product Catalogue / Product Vendor / Inventory Location */}
      <Route path="IMS/inventory/products" element={<ProductCatalog />} />
      <Route path="IMS/inventory/products/new" element={<AddEditProduct />} />
      <Route path="IMS/inventory/products/:productId/edit" element={<AddEditProduct />} />
      <Route path="IMS/inventory/products/:productId" element={<ProductDetail />} />
      <Route path="IMS/inventory/vendors" element={<VendorCatalog />} />
      <Route path="IMS/inventory/vendors/new" element={<AddEditVendor />} />
      <Route path="IMS/inventory/vendors/:vendorId/edit" element={<AddEditVendor />} />
      <Route path="IMS/inventory/vendors/:vendorId" element={<VendorDetail />} />
      <Route path="IMS/inventory/locations" element={<WarehouseList />} />
      <Route path="IMS/inventory/locations/new" element={<AddEditWarehouse />} />
      <Route path="IMS/inventory/locations/:id/edit" element={<AddEditWarehouse />} />
      <Route path="IMS/inventory/locations/:id" element={<WarehouseDetail />} />
      <Route path="IMS/inventory/locations/:id/configure" element={<ConfigureWarehouseStockLevels />} />
      
      <Route path="sales/configurations/pmc-cost-heads" element={<PmcCostHeadsPage />} />
      <Route path="sales/configurations/approval-rules" element={<PmcCostHeadsPage />} />
      <Route path="sales/configurations/net-price-configuration" element={<PmcCostHeadsPage />} />
      <Route path="sales/configurations/terms-library" element={<PmcCostHeadsPage />} />
      <Route path="sales/quotations/quotation" element={<QuotationPage />} />
      <Route path="sales/quotations/quotation/create" element={<QuotationCreatePage />} />
      <Route path="sales/quotations/quotation/:refId" element={<QuotationDetailPage />} />
      <Route path="sales/configurations/pdf-download-rules" element={<PmcCostHeadsPage />} />

      <Route path="hrms-ess/conveyance-claims" element={<MyConveyanceClaimsPage />} />
      <Route path="hrms-ess/conveyance-claims/rate-per-km/new" element={<RatePerKmClaimPage />} />
      <Route path="hrms-ess/conveyance-claims/rate-per-km/:claimId" element={<RatePerKmClaimPage />} />
      <Route path="hrms-ess/conveyance-claims/fixed-monthly/new" element={<FixedMonthlyClaimPage />} />
      <Route path="hrms-ess/conveyance-claims/fixed-monthly/:claimId" element={<FixedMonthlyClaimPage />} />
      <Route path="hrms-ess/conveyance-claims/maintenance/new" element={<VehicleMaintenanceClaimPage />} />
      <Route path="hrms-ess/conveyance-claims/maintenance/:claimId" element={<VehicleMaintenanceClaimPage />} />

      <Route path="hrms-team/conveyance-claims" element={<TeamConveyanceClaimsPage />} />
      <Route path="hrms-team/conveyance-claims/all" element={<AllConveyanceClaimsPage />} />
      <Route path="hrms-team/conveyance-claims/:claimId" element={<ClaimApprovalDetailPage />} />
      <Route path="hrms-team/config/expense-policy" element={<ConveyancePolicyConfigPage />} />

      <Route path="psm/tickets" element={<TicketsListPage />} />
      <Route path="psm/tickets/create" element={<CreateEditTicketPage />} />
      <Route path="psm/tickets/:requestId/edit" element={<EditTicketRoutePage />} />
      <Route path="psm/tickets/:requestId" element={<TicketDetailPage />} />

      <Route path="hrms-team/config/org-settings" element={<OrgSettingsPage />} />

      <Route path="hrms-team/employees/requests" element={<OnboardingRequestsPage />} />
      <Route path="hrms-team/employees/requests/:requestId" element={<OnboardingRequestDetailPage />} />

      <Route path="psm/tenant-requests" element={<TenantRequestsPage />} />

      <Route path="outstation-travel" element={<OTRListPage />}/>
      <Route path="outstation-travel/report" element={<OTRReportPage />}/>
      <Route path="outstation-travel/create" element={<CreateEditOTRPage />} />
      <Route path="outstation-travel/:otrId" element={<OTRDetailPage />}/>
      <Route path="outstation-travel/:otrId/edit" element={<CreateEditOTRPage />} />
      <Route path="outstation-travel/:id/expenses" element={<OTRExpenseSubmissionPage />} />
      <Route path="hrms-team/config/travel-policy" element={<TravelPolicyConfigPage />} />

      <Route path="fsm/products-services" element={<ProductServicesPage />} />
      <Route path="fsm/products-services/:productServiceId/complaints" element={<ProductComplaintTypesPage />} /> 
      {/* Generic fallback for any enabledServices submodule that has no
          dedicated page yet (see router/navigation.js). */}
      <Route path="services/:service/:module/:submodule" element={<SubmoduleFeaturesPage />} />
      {/*<Route path="*" element={<Navigate to="/hrms" replace />*/}
      <Route path="*" element={<Navigate to="/" replace />
    } />
    </Routes>
  );
}
